<div *ngIf="loading"
     class="loading-overlay">
  <i class="fa fa-2x fa-spinner fa-spin text-secondary"></i>
  <h3 class="mt-3 ml-1 text-secondary">Cargando...</h3>
</div>


<div *ngIf="modalPedidoOrigenSrv.loading"
     class="loading-overlay">
  <i class="fa fa-2x fa-spinner fa-spin text-secondary"></i>
  <h3 class="mt-3 ml-1 text-secondary">Cargando pedido origen...</h3>
</div>


<div class="row ">
  <div class="col-12">
    <div class="card border rounded animated fadeIn fast">
      <div class="card-body animated fadeIn fast">

        <!-- cabecera  -->
        <div *ngIf="!paramId"
             class="row mb-2">
          <div class="col-4">
            <div class="input-group border border-dark rounded">
              <input class="form-control"
                     type="text"
                     id="buscaTodo"
                     autofocus
                     placeholder="Buscar cualquier dato..."
                     [(ngModel)]="strBuscarTodo"
                     (keyup)="buscarTodo()" />
              <div class="input-group-append">
                <button class="btn btn-outline-secondary"
                        type="button"
                        title="Limpiar búsqueda"
                        (click)="limpiaBusca()">
                  <i class="fas fa-times"></i>
                </button>
              </div>
            </div>
          </div>

          <!-- cliSeleccionado -->
          <div class="col-3">
            <div class="input-group border border-dark rounded">
              <div class="input-group-addon"
                   title="Cliente">
                <i class="fa-solid fa-user"></i>
              </div>
              <select class="form-control"
                      [(ngModel)]="cliSeleccionado"
                      (ngModelChange)="onClienteSelect($event)">
                <option value=''>Todos los clientes</option>
                <option *ngFor="let cli of clientesList"
                        [value]=cli.id>
                  {{cli.nombre}}
                </option>
              </select>
            </div>
          </div>

          <!-- estadoSelect -->
          <div class="col-3">
            <div class="input-group border border-dark rounded">
              <div class="input-group-addon"
                   title="Estado del pedido"
                   style="cursor: default">
                <span>E</span>
              </div>
              <select class="form-control"
                      [(ngModel)]="estadoSelect"
                      (ngModelChange)="estadoSelectChange($event)">
                <option *ngFor="let estado of pedidosEstadosList"
                        [value]="estado.valor"
                        [ngClass]="{'text-warning': estado.valor === '99'}">
                  {{ estado.nombre }} ({{ estado.cantidad | number:'1.0-0':'es' }})
                </option>
              </select>
            </div>
          </div>

          <div class="col-2">
            <form>
              <div class="row float-right">
                <div class="col-sm-7">
                  <div class="form-group rounded">
                    <select class="form-control"
                            name="rowsLimitStr"
                            [(ngModel)]="rowsLimitStr"
                            (change)="rowsLimitChange()">
                      <option [value]="5">5</option>
                      <option [value]="10">10</option>
                      <option [value]="50">50</option>
                      <option [value]="100">100</option>
                      <option [value]="999999">Todo</option>
                    </select>
                  </div>
                </div>
                <div class="col-sm-5">
                  <div class="form-group float-right">
                    <div class="btn-group">
                      <button type="button"
                              (click)="getListaPedidos()"
                              class="btn btn-outline-info btn-circle"
                              title="Recargar datos">
                        <i class="fa-solid fa-sync"></i>
                      </button>
                      <button type="button"
                              (click)="exportToExcel()"
                              class="btn btn-outline-info btn-circle"
                              title="Descargar Excel">
                        <i class="fa-solid fa-download"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>

        <div class="rounded border">
          <!-- ngx-datatable -->
          <ngx-datatable class="bootstrap"
                         [style.width]="'100%'"
                         [limit]="rowsLimit"
                         [rows]="rows"
                         [columnMode]="ColumnMode.force"
                         [headerHeight]="50"
                         [footerHeight]="50"
                         [messages]="messages"
                         rowHeight="auto"
                         [summaryRow]="true"
                         [summaryHeight]="50"
                         [summaryPosition]="summaryPosition"
                         [rowClass]="getRowClass">


            <!-- id -->
            <ngx-datatable-column name="id"
                                  prop='id'
                                  [width]="90"
                                  [resizeable]="false"
                                  [cellClass]="'text-right align-middle'">
              <ng-template ngx-datatable-header-template
                           let-sort="sortFn"
                           let-column="column">
                <div class="header"
                     (click)="sort()"
                     style="margin-top: 33px;">
                  <h6 class="pointer link">Id</h6>
                </div>
              </ng-template>
              <ng-template let-value="value"
                           ngx-datatable-cell-template>
                <div [innerHTML]="funcLib.resaltarTexto(value, textoDestacado)"></div>
              </ng-template>
            </ngx-datatable-column>

            <!-- pedido_cli -->
            <ngx-datatable-column name="pedido_cli"
                                  prop='pedido_cli'
                                  [cellClass]="'align-middle'"
                                  [flexGrow]="1">
              <ng-template ngx-datatable-header-template
                           let-sort="sortFn"
                           let-column="column">
                <input type="search"
                       class="form-control form-control-sm"
                       placeholder="Buscar..."
                       (keyup)="buscar($event, 'pedido_cli')"><br>
                <div class="header"
                     (click)="sort()">
                  <h6 class="pointer link">Pedido</h6>
                </div>
              </ng-template>
              <ng-template let-value="value"
                           let-row="row"
                           ngx-datatable-cell-template>
                <div [class.font-weight-bold]="row.destacarLinea"
                     [class.text-primary]="row.destacarLinea"
                     [innerHTML]="funcLib.resaltarTexto(value, textoDestacado)"
                     title="Ref: {{row.ref_envio}}"></div>
              </ng-template>
            </ngx-datatable-column>

            <!-- fecha_pedidoExterno -->
            <ngx-datatable-column name="fecha_pedidoExterno"
                                  prop='fecha_pedidoExterno'
                                  [cellClass]="'align-middle'"
                                  [width]="110"
                                  [resizeable]="false">
              <ng-template ngx-datatable-header-template
                           let-sort="sortFn"
                           let-column="column">
                <input type="search"
                       class="form-control form-control-sm"
                       placeholder="Buscar..."
                       (keyup)="buscar($event, 'fecha_pedidoExterno')"><br>
                <div class="header"
                     (click)="sort()">
                  <h6 class="pointer link">Fecha</h6>
                </div>
              </ng-template>
              <ng-template let-value="value"
                           ngx-datatable-cell-template>
                <div [innerHTML]="funcLib.resaltarTexto(value, textoDestacado)"></div>
              </ng-template>
            </ngx-datatable-column>

            <!-- camp_cod -->
            <ngx-datatable-column name="camp_cod"
                                  prop='camp_cod'
                                  [cellClass]="'align-middle'"
                                  [width]="110"
                                  [resizeable]="false">
              <ng-template ngx-datatable-header-template
                           let-sort="sortFn"
                           let-column="column">
                <input type="search"
                       class="form-control form-control-sm"
                       placeholder="Buscar..."
                       (keyup)="buscar($event, 'camp_cod')"><br>
                <div class="header"
                     (click)="sort()">
                  <h6 class="pointer link">Campaña</h6>
                </div>
              </ng-template>
              <ng-template let-value="value"
                           let-row="row"
                           ngx-datatable-cell-template>
                <div class="d-flex align-items-center">
                  <span class="monospace"
                        [innerHTML]="funcLib.resaltarTexto(value, textoDestacado)"></span>
                </div>
              </ng-template>
            </ngx-datatable-column>

            <!-- cliNombre -->
            <ngx-datatable-column name="cliNombre"
                                  [cellClass]="'align-middle'"
                                  [width]="170">
              <ng-template ngx-datatable-header-template
                           let-sort="sortFn"
                           let-column="column">
                <input type="search"
                       class="form-control form-control-sm"
                       placeholder="Buscar..."
                       (keyup)="buscar($event, 'cliNombre')"><br>
                <div class="header"
                     (click)="sort()">
                  <h6 class="pointer link">Cliente</h6>
                </div>
              </ng-template>
              <ng-template let-value="value"
                           ngx-datatable-cell-template>
                <div [innerHTML]="funcLib.resaltarTexto(value, textoDestacado)"></div>
              </ng-template>
            </ngx-datatable-column>

            <!-- tipoPedido -->
            <ngx-datatable-column name="tipoPedido"
                                  prop='tipoPedido'
                                  [cellClass]="'align-middle'"
                                  [width]="90">
              <ng-template ngx-datatable-header-template
                           let-sort="sortFn"
                           let-column="column">
                <select class="form-control form-control-sm"
                        (change)="buscaTipo($event.target)">
                  <option value="">Todos</option>
                  <option value="B2B">B2B</option>
                  <option value="B2C">B2C</option>
                </select><br>
                <div class="header"
                     (click)="sort()">
                  <h6 class="pointer link">Tipo</h6>
                </div>
              </ng-template>
              <ng-template let-value="value"
                           let-row="row"
                           ngx-datatable-cell-template>
                <div [innerHTML]="funcLib.resaltarTexto(value, textoDestacado)"></div>
              </ng-template>
            </ngx-datatable-column>

            <!-- estado -->
            <ngx-datatable-column name="estado"
                                  prop='estado'
                                  [cellClass]="'align-middle'"
                                  [flexGrow]="1.0">
              <ng-template ngx-datatable-header-template
                           let-sort="sortFn"
                           let-column="column">
                <select class="form-control form-control-sm"
                        (change)="buscaEstado($event.target)">
                  <option value="">Todos</option>
                  <option *ngFor="let estado of pedidosEstadosList"
                          [value]="estado.valor">{{ estado.nombre }}</option>
                </select><br>
                <div class="header"
                     (click)="sort()">
                  <h6 class="pointer link">Estado</h6>
                </div>
              </ng-template>
              <ng-template let-value="value"
                           let-row="row"
                           ngx-datatable-cell-template>
                <span title="{{row.estado_at}}"
                      [innerHTML]=" row.estado | pedidoEstado "> </span>
              </ng-template>
            </ngx-datatable-column>

            <!-- cajetin -->
            <ngx-datatable-column name="cajetin"
                                  prop='cajetin'
                                  [width]="70"
                                  [resizeable]="false"
                                  [cellClass]="'text-right align-middle'">
              <ng-template ngx-datatable-header-template
                           let-sort="sortFn"
                           let-column="column">
                <div class="header"
                     (click)="sort()"
                     style="margin-top: 33px;">
                  <h6 class="pointer link">Cajetín</h6>
                </div>
              </ng-template>
              <ng-template let-value="value"
                           ngx-datatable-cell-template>
                <div [innerHTML]="funcLib.resaltarTexto(value, textoDestacado)"></div>
              </ng-template>
            </ngx-datatable-column>

            <!-- contrarrembolso -->
            <ngx-datatable-column name="contrarrembolso"
                                  prop='contrarrembolso'
                                  [width]="100"
                                  [resizeable]="false"
                                  [cellClass]="'text-right align-middle'">
              <ng-template ngx-datatable-header-template
                           let-sort="sortFn"
                           let-column="column">
                <div class="header"
                     (click)="sort()"
                     style="margin-top: 33px;">
                  <h6 class="pointer link">Reembolso</h6>
                </div>
              </ng-template>
              <ng-template let-value="value"
                           ngx-datatable-cell-template>
                {{ value | number: '0.2-2':'es' }} €
              </ng-template>
            </ngx-datatable-column>

            <!-- tot_referencias -->
            <ngx-datatable-column name="tot_referencias"
                                  prop='tot_referencias'
                                  [width]="90"
                                  [resizeable]="false"
                                  [cellClass]="'text-right align-middle'"
                                  [summaryFunc]="sumaCeldas">
              <ng-template ngx-datatable-header-template
                           let-sort="sortFn"
                           let-column="column">
                <div class="header"
                     (click)="sort()"
                     style="margin-top: 33px;">
                  <h6 class="pointer link">Refs</h6>
                </div>
              </ng-template>
              <ng-template let-value="value"
                           ngx-datatable-cell-template>
                {{ value | number: '1.0-0':'es' }}
              </ng-template>
            </ngx-datatable-column>

            <!-- tot_articulos -->
            <ngx-datatable-column name="tot_articulos"
                                  prop='tot_articulos'
                                  [width]="90"
                                  [resizeable]="false"
                                  [cellClass]="'text-right align-middle'"
                                  [summaryFunc]="sumaCeldas">
              <ng-template ngx-datatable-header-template
                           let-sort="sortFn"
                           let-column="column">
                <div class="header"
                     (click)="sort()"
                     style="margin-top: 33px;">
                  <h6 class="pointer link">Arts</h6>
                </div>
              </ng-template>
              <ng-template let-value="value"
                           ngx-datatable-cell-template>
                <span [ngClass]="{'text-white bg-danger bg-opacity-10 px-2 rounded': value < 1}">
                  {{ value | number: '1.0-0':'es' }}
                </span>
              </ng-template>
            </ngx-datatable-column>

            <!-- cod_servicio -->
            <ngx-datatable-column name="cod_servicio"
                                  prop='cod_servicio'
                                  [cellClass]="'align-middle'"
                                  [width]="90"
                                  [resizeable]="false">
              <ng-template ngx-datatable-header-template
                           let-sort="sortFn"
                           let-column="column">
                <div class="header"
                     (click)="sort()"
                     style="margin-top: 33px;">
                  <h6 class="pointer link">Servicio</h6>
                </div>
              </ng-template>
              <ng-template let-value="value"
                           let-row="row"
                           ngx-datatable-cell-template>
                <div [ngClass]="{ 'text-warning font-weight-bold' : row.cod_servicio === 'inte' }"
                     [innerHTML]="funcLib.resaltarTexto(row.cod_servicio, textoDestacado)"
                     title="{{row.servicio?.nombre}}"></div>
              </ng-template>
            </ngx-datatable-column>

            <!-- dirección -->
            <ngx-datatable-column name="direccion"
                                  [cellClass]="'align-middle'"
                                  [width]="115"
                                  [resizeable]="false">
              <ng-template ngx-datatable-header-template
                           let-sort="sortFn"
                           let-column="column">
                <input type="search"
                       class="form-control form-control-sm"
                       placeholder="Buscar"
                       (keyup)="buscar($event, 'direccion')"><br>
                <div class="header"
                     (click)="sort()">
                  <h6 class="pointer link">Enviar a</h6>
                </div>
              </ng-template>
              <ng-template let-row="row"
                           let-value="value"
                           ngx-datatable-cell-template>
                <div class="text-center"
                     [innerHTML]="funcLib.resaltarTexto( (row.cp), textoDestacado)"
                     title="{{row.provincia}}"></div>
              </ng-template>
            </ngx-datatable-column>


            <!-- Acciones Menú -->
            <ngx-datatable-column [width]="80"
                                  [cellClass]="'align-middle'"
                                  [sortable]="false"
                                  [resizeable]="false">
              <ng-template let-row="row"
                           let-rowIndex="rowIndex"
                           let-value="value"
                           ngx-datatable-cell-template>

                <div ngbDropdown
                     class="d-inline-block "
                     container="body"
                     placement="top-right">


                  <a (click)="infoClickPedido(row)"
                     class="link mr-1 pointer"
                     data-toggle="tooltip"
                     title="INFORMACIÓN de este pedido">
                    <span class="acciones-badge"
                          [ngClass]="{'infoSelect': row.id == pedidoSelected.id}">I</span>
                  </a>



                  <button class="btn btn-sm btn-outline-secondary dropdown-toggle"
                          data-toggle="dropdown"
                          type="button"
                          style="border-width: 1px;">
                    <i class="fa-solid fa-ellipsis-vertical"></i>
                  </button>

                  <div class="dropdown-menu dropdown-menu-center">

                    <!-- Opciones de ALBARÁN -->
                    <div class="dropdown-submenu">
                      <a class="link mr-2 dropdown-item dropdown-toggle pointer"
                         title="Opciones de Packing List">
                        <i class="fa-solid fa-file-invoice"></i> Packing List
                      </a>
                      <div class="dropdown-menu">
                        <a (click)="(row.estado === '3' || row.estado === '5' ) ? descargaAlbaranClick(row.id!) : null"
                           class="link mr-2 dropdown-item pointer"
                           placement="top"
                           title="Abrir PDF del Packing List"
                           [ngClass]="{'disabled':( row.estado !== '3' && row.estado !== '5') }">
                          <i class="fa-solid fa-file-pdf"></i> Abrir Packing List
                        </a>

                        <a (click)="( (row.estado === '3' || row.estado === '5') && row.cliAlbaranEnXls === '1' ) ? descargaAlbaranXls(row.id!) : null"
                           class="link mr-2 dropdown-item pointer"
                           placement="top"
                           title="Descargar Packing List en formato EXCEL"
                           [ngClass]="{'disabled':!( (row.estado === '3' || row.estado === '5') && row.cliAlbaranEnXls === '1' ) }">
                          <i class="fa-solid fa-file-excel"></i> Descargar Packing List XLS
                        </a>

                        <a (click)="(row.estado === Constantes.ESTADO_PEDIDO_SERVIDO || row.estado === Constantes.ESTADO_PEDIDO_SERVIDO_PARCIALMENTE) ? generaPdfEnvio(row) : null"
                           class="link mr-2 dropdown-item pointer"
                           placement="top"
                           title="Generar NUEVO Packing List para este pedido"
                           [ngClass]="{'disabled':( row.estado !== Constantes.ESTADO_PEDIDO_SERVIDO  && row.estado !== Constantes.ESTADO_PEDIDO_SERVIDO_PARCIALMENTE) }">
                          <i class="fa-solid fa-file-circle-plus"></i> Generar nuevo Packing List
                        </a>

                      </div>
                    </div>


                    <!-- Opciones de Pedido -->
                    <div class="dropdown-submenu">
                      <a class="link mr-2 dropdown-item dropdown-toggle pointer"
                         title="Opciones de Pedido">
                        <i class="fa-solid fa-receipt"></i> Pedido
                        <span *ngIf="row.fac_pack_estado==='2'"
                              class="badge rounded-circle bg-success ms-2"
                              style="width: 10px; height: 10px; padding: 5;">&nbsp;</span>
                      </a>
                      <div class="dropdown-menu">

                        <a (click)="(row.estado === '3' || row.estado === '5' ) ? openTracking(row.id!) : null"
                           class="link mr-2 dropdown-item pointer"
                           placement="top"
                           title="TRACKING del pedido"
                           [ngClass]="{'disabled':( row.estado !== '3' && row.estado !== '5') }">
                          <i class="fa-solid fa-location-dot"></i> Tracking del pedido
                        </a>

                        <a (click)="abrirModalCabeza(row,rowIndex)"
                           class="link mr-2 dropdown-item pointer"
                           placement="top"
                           title="Modificar la CABECERA del pedido">
                          <i class="fa-solid fa-pen-to-square"></i> Cabecera del pedido
                        </a>

                        <a (click)="abrirModalFacturacion(row,rowIndex)"
                           class="link mr-2 dropdown-item pointer"
                           placement="top"
                           title="Cantidad de PACKAGING utilizado">
                          <i class="fa-solid fa-pen-to-square"></i> Packaging del pedido
                          <span *ngIf="row.fac_pack_estado==='2'"
                                class="badge rounded-circle bg-success ms-2"
                                style="width: 10px; height: 10px; padding: 5;">&nbsp;</span>
                        </a>

                        <a (click)="crearComplementario(row,rowIndex)"
                           class="link mr-2 dropdown-item pointer"
                           placement="top"
                           title="Crear un pedido COMPLEMENTARIO con el resto de artículos"
                           [ngClass]="{'disabled':( row.estado !== '5' ) }">
                          <i class="fa-solid fa-circle-plus"></i> Crear complementario

                          <span *ngIf="row.i_complemetarios"
                                class="badge rounded-circle bg-success ms-2"
                                style="width: 10px; height: 10px; padding: 5;">&nbsp;</span>
                        </a>


                        <a (click)="abrirModalOrigenPedido(row,rowIndex)"
                           class="link mr-2 dropdown-item pointer"
                           placement="top"
                           title="Ver los datos del ORIGEN del pedido">
                          <i class="fa-solid fa-info-circle"></i> Origen del pedido
                        </a>

                      </div>
                    </div>


                    <div class="dropdown-divider"></div>



                    <a (click)="(row.cod_servicio === 'inte') ? pdfEtiquetaPedido(row) : null"
                       class="link mr-2 dropdown-item"
                       placement="top"
                       title="Imprmir ETIQUETA de este pedido (Servicio Inte)"
                       [ngClass]="{'disabled': !(row.cod_servicio === 'inte')}">
                      <i class="fa-solid fa-print"></i> Imprimir etiqueta Inte
                    </a>

                    <a (click)="(row.estado === Constantes.ESTADO_PEDIDO_SERVIDO || row.estado === Constantes.ESTADO_PEDIDO_SERVIDO_PARCIALMENTE) ? labelCajas(row) : null"
                       class="link mr-2 dropdown-item"
                       placement="top"
                       title="Imprimir etiquetas con el contenido de las cajas de este pedido"
                       [ngClass]="{'disabled':( row.estado !== Constantes.ESTADO_PEDIDO_SERVIDO  && row.estado !== Constantes.ESTADO_PEDIDO_SERVIDO_PARCIALMENTE) }">
                      <i class="fa-solid fa-boxes-stacked"></i> Imprimir contenido de cajas
                    </a>

                    <a (click)="(row.estado === Constantes.ESTADO_PEDIDO_SERVIDO || row.estado === Constantes.ESTADO_PEDIDO_SERVIDO_PARCIALMENTE) ? generaXlsEnvio(row) : null"
                       class="link mr-2 dropdown-item"
                       placement="top"
                       title="Exportar este pedido a DTX"
                       [ngClass]="{'disabled':( row.estado !== Constantes.ESTADO_PEDIDO_SERVIDO  && row.estado !== Constantes.ESTADO_PEDIDO_SERVIDO_PARCIALMENTE) }">
                      <i class="fa-solid fa-file-excel"></i> Exportar a DTX
                    </a>

                    <a (click)='abrirModalAvisos(row)'
                       class="link mr-2 dropdown-item"
                       placement="top"
                       title="Ver NOTIFICACIONES del cliente sobre este pedido"
                       [ngClass]="{'disabled':( row.tot_avisos == 0)}">
                      <i class="fa-solid fa-envelope"></i> Ver notificaciones del cliente
                      <span *ngIf=" row.tot_avisos! >0"
                            class="badge rounded-circle bg-success ms-2"
                            style="width: 10px; height: 10px; padding: 5;">&nbsp;</span>
                    </a>

                  </div>
                </div>

              </ng-template>
            </ngx-datatable-column>






          </ngx-datatable>
        </div>



        <!-- barra + botón carga más -->
        <div class="d-flex align-items-center mb-2"
             *ngIf="rows.length < recTotal ">
          <div class="d-flex align-items-center"
               *ngIf="mostrarCargaMas">

            <!-- Texto y barra en vertical -->
            <div class="d-flex flex-column me-3">
              <p class="mb-1">
                <strong>Últimos {{ lista.length | number:'1.0-0' }} de {{ recTotal | number:'1.0-0' }}</strong>
              </p>
              <div class="progress"
                   style="height: 12px; width: 220px;">
                <div class="progress-bar bg-success"
                     role="progressbar"
                     [style.width.%]="(rows.length / recTotal) * 100"
                     [attr.aria-valuenow]="(rows.length / recTotal) * 100"
                     aria-valuemin="0"
                     aria-valuemax="100">
                </div>
              </div>
            </div>

            <!-- Botón a la derecha -->
            <div class="mt-2 ml-2">
              <button [disabled]="loading"
                      (click)="cargaMas()"
                      type="button"
                      class="btn btn-rounded btn-outline-success waves-effect waves-light mr-2">
                <i *ngIf="loading"
                   class="fa fa-spinner fa-spin me-1"></i>
                Cargar más
              </button>
            </div>
          </div>
        </div>




      </div>
    </div>
  </div>


  <!-- Tabla de detalle del pedido -->
  <div id="detallesPedido"
       *ngIf="pedidoSelected.id"
       class="col-12">
    <app-pedido-detall [pedidoDetall]="pedidoSelected"
                       [eanSeleccionado]="''"></app-pedido-detall>
  </div>
</div>


<!-- modal para facturación de pedidos -->
<app-modal-fact-salida></app-modal-fact-salida>


<!-- modal para edición de la cabecera del pedido -->
<app-modal-pedido-cabecera></app-modal-pedido-cabecera>


<!-- modal para avisos del pedido -->
<app-modal-pedido-avisos></app-modal-pedido-avisos>


<!-- modal para origen del pedido -->
<app-modal-pedido-origen></app-modal-pedido-origen>